import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
// import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import FirmsPage from './pages/admin/FirmsPage';
import ApplicationsPage from './pages/admin/ApplicationsPage';
import UsersPage from './pages/admin/UsersPage';
import LogsPage from './pages/admin/LogsPage';
import SettingsPage from './pages/admin/SettingsPage';
import IntegrationsPage from './pages/admin/IntegrationsPage';
import MessagePoolPage from './pages/admin/MessagePoolPage';
import QRPage from './pages/QRPage';
import DashboardPage from './pages/DashboardPage';
import WhatsAppLogsPage from './pages/WhatsAppLogsPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import './App.css';

// Auth check functions
const isAuthenticated = () => !!sessionStorage.getItem('authToken');
const isAdmin = () => sessionStorage.getItem('userRole') === 'admin';
const isOldAdminAuth = () => !!localStorage.getItem('admin_token');

// Protected Route for normal users
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// Protected Route for admin only
const AdminProtectedRoute = ({ children }) => {
  if (!isAuthenticated() || !isAdmin()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// Legacy admin route protection
const LegacyAdminRoute = ({ children }) => {
  // Önce yeni sistem kontrol et
  const isNewAdmin = isAuthenticated() && isAdmin();
  if (isNewAdmin) {
    return children;
  }
  
  // Eski sistem kontrol et
  const hasAdminToken = !!localStorage.getItem('admin_token');
  if (!hasAdminToken) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// Navigation Component removed - using individual page layouts instead

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Main Login Page */}
          <Route path="/" element={
            isAuthenticated() ? (
              isAdmin() ? <Navigate to="/admin" replace /> : <Navigate to="/dashboard" replace />
            ) : <LoginPage />
          } />
          
          {/* Login Page - Explicit Route */}
          <Route path="/login" element={
            (() => {
              // Admin token kontrolü - eğer admin token varsa, redirect yapma
              const urlParams = new URLSearchParams(window.location.search);
              const adminToken = urlParams.get('admin_token');
              if (adminToken) {
                // Admin token varsa, LoginPage'i göster (otomatik login yapılacak)
                return <LoginPage />;
              }
              
              // Normal login kontrolü
              if (isAuthenticated()) {
                return isAdmin() ? <Navigate to="/admin" replace /> : <Navigate to="/dashboard" replace />;
              }
              return <LoginPage />;
            })()
          } />
          
          {/* User Dashboard */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          
          <Route path="/whatsapp-logs" element={
            <ProtectedRoute>
              {/* Logs sayfasını dashboard içinde aç */}
              <DashboardPage defaultTab="whatsapp-logs-detail" />
            </ProtectedRoute>
          } />
          
          {/* Password Change */}
          <Route path="/change-password" element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          } />
          
          {/* Forgot Password */}
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* QR Page (accessible to authenticated users) */}
          <Route path="/qr/:slug" element={
            <ProtectedRoute>
              <QRPage />
            </ProtectedRoute>
          } />
          
          {/* Legacy Admin Login - Artık kullanılmıyor */}
          {/* <Route path="/admin/login" element={<AdminLoginPage />} /> */}
          
          {/* Admin Routes */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          
          <Route path="/admin/dashboard" element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          } />
          
          <Route path="/admin/firms" element={
            <AdminProtectedRoute>
              <FirmsPage />
            </AdminProtectedRoute>
          } />
          
          <Route path="/admin/applications" element={
            <AdminProtectedRoute>
              <ApplicationsPage />
            </AdminProtectedRoute>
          } />
          
          <Route path="/admin/users" element={
            <AdminProtectedRoute>
              <UsersPage />
            </AdminProtectedRoute>
          } />
          
          <Route path="/admin/logs" element={
            <AdminProtectedRoute>
              <LogsPage />
            </AdminProtectedRoute>
          } />

          <Route path="/admin/integrations" element={
            <AdminProtectedRoute>
              <IntegrationsPage />
            </AdminProtectedRoute>
          } />

          <Route path="/admin/message-pool" element={
            <AdminProtectedRoute>
              <MessagePoolPage />
            </AdminProtectedRoute>
          } />
          
          
          <Route path="/admin/settings" element={
            <AdminProtectedRoute>
              <SettingsPage />
            </AdminProtectedRoute>
          } />
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;